import BaseRailsRequestController from "./base_rails_request_controller";
import TomSelect from "tom-select";

// Connects to data-controller="rule-fields"
export default class extends BaseRailsRequestController {
  static classes = ["noType", "loadingTypes", "loadingOptions"];
  static targets = ["ruleTypeSelect", "valueOptionSelect", "ruleTypeInput"];

  static values = {
    noResultsMessage: String,
  };

  connect() {
    this.url = this.element.dataset.url;
    const thisInstance = this;

    // Initialize the rule_type select
    new TomSelect(this.ruleTypeSelectTarget, {
      valueField: "id",
      labelField: "rule_type_name",
      sortField: [{ field: "$order" }, { field: "$score" }],
      controlInput: null,
      plugins: ["dropdown_input"],
      searchField: ["rule_type_name"],
      onChange: function (value) {
        const selectedOption = this.getItem(value);
        const url = selectedOption.dataset.url;
        thisInstance.getValueOptions(url);
      },
      onInitialize: function () {
        thisInstance.element.classList.add(thisInstance.loadingTypesClass);
        thisInstance
          .fetchWithProgress("get", thisInstance.url)
          .then((response) => response.json)
          .then((json) => {
            const value = thisInstance.ruleTypeSelectTarget.dataset.selectedRuleType;

            this.addOptions(json.items);

            if (value) {
              this.setValue(value, true);
            }
          })
          .finally(() => {
            thisInstance.element.classList.remove(thisInstance.loadingTypesClass);
            thisInstance.ruleTypeSelectTarget.dispatchEvent(new CustomEvent("tom-select:ready"));
          });
      },
      render: {
        option: function (data, escape) {
          return "<div data-fields-to-disable='" + escape(data.fields_to_disable.join(",")) + "'>" + escape(data.rule_type_name) + "</div>";
        },
        item: function (data, escape) {
          return `<div data-url="${escape(data.url)}" >${escape(data.rule_type_name)}</div>`;
        },
        no_results: () => {
          return `<div class="no-results">${this.noResultsMessageValue}</div>`;
        },
      },
    });
  }

  valueOptionSelected() {
    this.disableUsedValueOptions();
  }

  getValueOptions(url) {
    this.element.classList.add(this.loadingValuesClass);

    this.fetchWithProgress("get", url, {
      responseKind: "turbo-stream",
    }).finally(() => {
      this.element.classList.remove(this.loadingValuesClass);
    });
  }

  valueOptionSelectTargetConnected(target) {
    target.addEventListener(
      "tom-select:ready",
      () => {
        this.disableUsedValueOptions();
      },
      { once: true }
    );
  }

  valueOptionSelectTargetDisconnected() {
    this.disableUsedValueOptions();
  }

  disableUsedValueOptions() {
    const usedValueOptionIds = this.getUsedValueOptionIds();

    this.valueOptionSelectTargets.forEach((valueOptionSelect) => {
      const valueOptionTomSelect = valueOptionSelect.tomselect;
      // Re-enable all options
      Object.keys(valueOptionTomSelect.options).forEach((optionValue) => {
        valueOptionTomSelect.options[optionValue].disabled = false;
        valueOptionTomSelect.updateOption(optionValue, valueOptionTomSelect.options[optionValue]);
      });

      // Disable used options
      usedValueOptionIds.forEach((usedvalueOptionId) => {
        if (valueOptionTomSelect.options[usedvalueOptionId]) {
          valueOptionTomSelect.options[usedvalueOptionId].disabled = true;
          valueOptionTomSelect.updateOption(usedvalueOptionId, valueOptionTomSelect.options[usedvalueOptionId]);
        }
      });
      valueOptionTomSelect.refreshOptions(false);
    });
  }

  getUsedValueOptionIds() {
    return this.valueOptionSelectTargets.map((valueOptionSelect) => {
      return valueOptionSelect.value;
    });
  }
}
